export default __webpack_public_path__ + "static/media/hypio.1779b969.png";